import Clock from "@assets/icons/clock.svg";
import { useCountdown } from "@hooks/use-countdown";

export type TimerProps = {
  endDate: Date;
  withIcon?: boolean;
  styles?: {
    wrapper?: React.CSSProperties;
    label?: React.CSSProperties;
  }
};

export const Timer = ({ endDate, withIcon = true, styles }: TimerProps) => {
  // Calculate initial remaining seconds (endDate - current time)
  const initialRemaining = Math.max(
    0,
    Math.ceil((endDate.getTime() - Date.now()) / 1000)
  );

  const displaySeconds = useCountdown(initialRemaining);

  // Format time as MM:SS
  const formatTime = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / 3600);
    const secs = totalSeconds % 60;
    if (hours > 0) {
      const minutes = Math.floor(totalSeconds / 60) % 60;
      // Format as HH:MM:SS when hours exist
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    }
    const minutes = Math.floor(totalSeconds / 60);
    // Format as MM:SS when no hours
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div>
      <h3 style={{ display: "flex", ...styles?.wrapper }}>
        <span
          style={{
            fontVariantNumeric: "tabular-nums",
            fontFamily: "'Inter', sans-serif",
            lineHeight: "1.5",
            ...styles?.label
          }}
        >
          {formatTime(displaySeconds)}
        </span>{" "}
        {withIcon && <Clock />}
      </h3>
    </div>
  );
};
